export default __webpack_public_path__ + "static/media/product-09 (1).5fb94d2d.jpg";